import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { setAuthState } from '../../../../../store/actions/facebook-messenger';
import {
  CURRENT_FACEBOOK_APP,
  getUserLongLivedAccessToken,
  FACEBOOK_SCOPE,
} from './facebook-api';

const FACEBOOK_ICON =
  'https://static.xx.fbcdn.net/rsrc.php/v3/yN/r/szGrb_tkxMW.png?_nc_eui2=AeHj8mie0ILyqOZDYyQmRNJTngYK2FVLuj6eBgrYVUu6Pjfb9Gm-pm9OqFO7AiXmXjwtSKvYXGRvG2HUh9wlafHZ';

/**
 * Component for render the facebook login button
 * Can be a custom layout for button (passe the function, customButton prop, that render the custom button)
 *
 * @param {*} props
 * @returns
 */
const ChannelFacebookMessengerLoginButton = (props) => {
  const { i18n, facebookAuth, setAuthState, title, customButton, user } = props;

  /**
   * Called when the attempted for login on Facebook is finished.
   * @param {Object} response
   */
  const responseFacebook = (response) => {
    if (response.status !== 'unknown') {
      getUserLongLivedAccessToken(response.accessToken).then((resolve) => {
        if (!resolve.hasOwnProperty('facebookSuccess')) {
          setAuthState({ ...response, longLivedAccessToken: { ...resolve } });
        }
      });
    }
  };

  /**
   * Render custom facebook login button for react lib
   * @param {Object} renderProps
   */
  const renderCustomFacebookLoginButton = (renderProps) => {
    return (
      <button
        type="button"
        disabled={!!(user && user.selectedCompany?.claim?.name === 'Viewer')}
        onClick={renderProps.onClick}
        className="facebook-login-button"
      >
        <div className="facebook-button-container">
          <img src={FACEBOOK_ICON} className="facebook-icon" alt="" />
          <div className="facebook-login-text">{i18n.t(title)}</div>
        </div>
      </button>
    );
  };

  return (
    <FacebookLogin
      appId={CURRENT_FACEBOOK_APP.id}
      fields="name,email,picture"
      scope={FACEBOOK_SCOPE}
      callback={customButton || responseFacebook}
      render={(renderProps) =>
        customButton
          ? customButton(renderProps)
          : renderCustomFacebookLoginButton(renderProps)
      }
    />
  );
};

const mapStateToProps = (state) => {
  return {
    facebookAuth: state.facebookAuth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ setAuthState }, dispatch);
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ChannelFacebookMessengerLoginButton))
);
